export const APIBaseURL = "/api";
export const APIMapBaseURL = "/mapapi";
